import { render, staticRenderFns } from "./FBA.vue?vue&type=template&id=fead325c&scoped=true"
import script from "./FBA.vue?vue&type=script&lang=js"
export * from "./FBA.vue?vue&type=script&lang=js"
import style0 from "./FBA.vue?vue&type=style&index=0&id=fead325c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fead325c",
  null
  
)

export default component.exports